import {
  FETCH_PROMOS,
  FETCH_PROMOS_SUCCESS,
  FETCH_PROMOS_FAILED,
  EDIT_PROMOS
} from "../store/types";
import { getSupabase } from '../config/configureSupabase';
import store from '../store/store';

export const fetchPromos = () => async (dispatch) => {
  dispatch({
    type: FETCH_PROMOS,
    payload: null
  });

  dispatch({
    type: FETCH_PROMOS_SUCCESS,
    payload: []
  });
};

export const editPromo = (promo, method) => async (dispatch) => {
  dispatch({
    type: EDIT_PROMOS,
    payload: { method, promo }
  });

  const supabase = getSupabase();
  if (supabase) {
    try {
      if (method === 'Add') {
        await supabase.from('promos').insert([promo]);
      } else if (method === 'Delete') {
        await supabase.from('promos').delete().eq('id', promo.id);
      } else {
        await supabase.from('promos').update(promo).eq('id', promo.id);
      }
    } catch (e) {}
  }
};